import axios from "axios";
import { AI_NEXUS_API_URL } from "../config";
import type {
  ProductsResponse,
  CreateTransactionRequest,
  CreateTransactionResponse,
  VerifyWalletRequest,
  VerifyWalletResponse,
} from "../types/ai-nexus-api.types";

// Create axios instance
const aiNexusApi = axios.create({
  baseURL: `${AI_NEXUS_API_URL}/BlockchainService_v1`,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// API Service functions
export const aiNexusApiService = {
  /**
   * Get all available products
   */
  async getProducts(): Promise<ProductsResponse> {
    const response = await aiNexusApi.get<ProductsResponse>(
      "/transactions/products"
    );
    return response.data;
  },

  /**
   * Create a transaction for a specific product
   */
  async createTransaction(
    request: CreateTransactionRequest
  ): Promise<CreateTransactionResponse> {
    const response = await aiNexusApi.post<CreateTransactionResponse>(
      "/transactions/create",
      request
    );
    return response.data;
  },

  /**
   * Verify if a wallet is linked/verified
   */
  async verifyWallet(
    request: VerifyWalletRequest
  ): Promise<VerifyWalletResponse> {
    try {
      const response = await aiNexusApi.post<VerifyWalletResponse>(
        "/wallets/verify-wallet",
        request
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        return {
          message: "Wallet not verified",
          valid: false,
        };
      }
      throw error;
    }
  },
};
